<template>
  <div class="row">

      <div class="col-sm-12">
          <referral-history />
      </div>
    <transition name="el-fade-in-linear" mode="out-in">

      
      <div key="History" class="col-md-12 card">
        <div class="card-header">
          <h4 class="card-title">Referrals</h4>
          <div class="category">Organisations registered with Qualification Check after referral from your organisation.</div>
        </div>
        <div class="card-content row form-horizontal">
          <div >
            <div class="col-sm-12">
              <el-table class="table table-striped table-no-bordered table-hover"
                        ref="listTable"
                        :data="history"
                        v-loading="paging"
                        element-loading-spinner="qc-spinner"
                        style="width: 100%"
                        highlight-current-row
                        tooltip-effect="light">
                <el-table-column label="Name">
                  <template slot-scope="props">
                    <span>{{props.row.name}}</span>
                  </template>
                </el-table-column>
                <el-table-column :max-width="50" label="Type" fixed="right" align="center">
                  <template slot-scope="props">
                    <span v-if="props.row.type == 'C'">Company</span>
                    <span v-else-if="props.row.type == 'I'">Institute</span>
                    <span v-else>Unknown</span>
                  </template>
                </el-table-column>
                <slot name="actions" />
              </el-table>
            </div>
            <div class="col-sm-6 pagination-info">
              <p class="category">Showing {{from + 1}} to {{to}} of {{total}} entries</p>
            </div>
            <div class="col-sm-6">
              <p-pagination class="pull-right"
                            v-model="pagination.currentPage"
                            :per-page="pagination.perPage"
                            :total="pagination.total">
              </p-pagination>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>

  import PPagination from 'src/components/Pagination.vue'
  import ReferralHistory from 'src/views/Referrals/History'
  import _ from 'lodash'

  export default {
    name: "referral-list",
    components: {
      PPagination,
      'referral-history': ReferralHistory,
    },
    data () {
      return {
        history: null,
        paging: false,
        total: 0,
        size: 20,
        pagination: {
          perPage: 20,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50],
          total: 0
        },
      }
    },
    mounted () {
      if(!this.items) {
        this.getHistory()
      }
    },
    activated () {
      if(!this.items) {
        this.getHistory()
      }
    },
    watch: {
    },
    computed: {
      paginationCurrentPage () {
        return this.pagination.currentPage
      },
      paginationPerPag () {
        return this.pagination.perPage
      },
      to () {
        let highBound = this.from + this.pagination.perPage
        if (this.total < highBound) {
          highBound = this.total
        }
        return highBound
      },
      from () {
        return this.pagination.perPage * (this.pagination.currentPage - 1)
      }
    },
    methods: {
      getHistory: _.debounce(function () {
        this.paging = true
        this.history = []
        let listRequest = {
          page: this.pagination.currentPage - 1,
          size: this.size
        }
        this.$api.getReferralList(listRequest)
          .then(response => {
            this.history = response.data.content
            this.pagination.total = response.data.totalSize
            this.total = response.data.totalSize
            this.paging = false
          })
          .catch(error => {
            this.paging = false
          })
      }, 500)
    }
  }
</script>
<style>

</style>
